export default __webpack_public_path__ + "images/089ffeabb634eed7f027e4cbaeac2504.svg";